import { Component, input } from '@angular/core';
import { Tone, toneClass } from './tone';

// The frame both kinds of card share: coloured top edge, title and status badge, an old-data note and a footer
// with the portal link. The card puts what it shows in the slots:
// [card-title], [card-badge-extra], the body, and [card-meta] for the line beside the portal link.
@Component({
  selector: 'app-card',
  templateUrl: './card.html',
  styleUrl: './card.css',
})
export class Card {
  readonly tone = input<Tone>('neutral');
  readonly badge = input.required<string>();
  readonly portalUrl = input<string | null>(null);
  // Set when the reading is older than the page allows; says how old it is.
  readonly staleAge = input<string | null>(null);

  protected toneClass(): string {
    return toneClass(this.tone());
  }
}
